"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsonld = require("jsonld");
const MappingsCollection_1 = require("../DataModel/Collections/MappingsCollection");
const ResourceFilterableCollection_1 = require("../DataModel/Collections/ResourceFilterableCollection");
const TypesCollection_1 = require("../DataModel/Collections/TypesCollection");
const namespaces_1 = require("../namespaces");
function linksAndOperations(mappings) {
    mappings[namespaces_1.hydra.template] = {
        default: "",
        propertyName: "template",
        required: true,
        type: [namespaces_1.hydra.IriTemplate]
    };
    mappings[namespaces_1.hydra.mapping] = {
        default: iriTemplateMappings => new MappingsCollection_1.default(iriTemplateMappings),
        propertyName: "mappings",
        required: true,
        type: [namespaces_1.hydra.IriTemplate]
    };
    mappings[namespaces_1.hydra.variable] = {
        default: "",
        propertyName: "variable",
        required: true,
        type: [namespaces_1.hydra.IriTemplateMapping]
    };
    mappings[namespaces_1.hydra.variableRepresentation] = {
        default: representations => representations[0] || null,
        propertyName: "variableRepresentation",
        required: true,
        type: [namespaces_1.hydra.IriTemplateMapping]
    };
    mappings[namespaces_1.hydra.expects] = {
        default: expected => new ResourceFilterableCollection_1.default(expected),
        propertyName: "expects",
        required: true,
        type: [namespaces_1.hydra.Operation]
    };
    mappings[namespaces_1.hydra.returns] = {
        default: returned => new ResourceFilterableCollection_1.default(returned),
        propertyName: "returns",
        required: true,
        type: [namespaces_1.hydra.Operation]
    };
    mappings[namespaces_1.hydra.expectsHeader] = {
        propertyName: "expectedHeaders",
        required: true,
        type: [namespaces_1.hydra.Operation]
    };
    mappings[namespaces_1.hydra.returnsHeader] = {
        propertyName: "returnedHeaders",
        required: true,
        type: [namespaces_1.hydra.Operation]
    };
    mappings[namespaces_1.hydra.method] = {
        default: "GET",
        propertyName: "method",
        required: true,
        type: [namespaces_1.hydra.Operation]
    };
    mappings.relation = {
        default: (value, processingState) => processingState.currentResource.iri,
        propertyName: "relation",
        required: true,
        type: [namespaces_1.hydra.Link, namespaces_1.hydra.TemplatedLink]
    };
    mappings.baseUrl = {
        default: (value, processingState) => processingState.baseUrl,
        propertyName: "baseUrl",
        required: true,
        type: [namespaces_1.hydra.Link, namespaces_1.hydra.TemplatedLink, namespaces_1.hydra.Operation]
    };
    mappings.target = {
        default: (value, processingState) => {
            const iri = jsonld.url.prependBase(processingState.baseUrl, processingState.ownerIri);
            return processingState.getVisitedResource(iri) || { iri, type: TypesCollection_1.default.empty };
        },
        propertyName: "target",
        required: true,
        type: [namespaces_1.hydra.Link, namespaces_1.hydra.TemplatedLink, namespaces_1.hydra.Operation]
    };
    return mappings;
}
exports.linksAndOperations = linksAndOperations;
//# sourceMappingURL=linksAndOperations.js.map